import { createFileRoute } from "@tanstack/react-router";
import AdminPartsTemplate from "@/pages/admin/AdminPartsTemplate";

export const Route = createFileRoute("/_adminLayout/admin/parts/template")({
  component: AdminPartsTemplate,
});
